<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

Chart.defaults.scale.gridLines.display = false; //

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ["chartData", "titulo", "legend"],
  data() {
    return {
      options: {
        layout: {
          padding: {
            bottom: 0
          }
        },
        legend: {
          display: this.legend,
          position: "bottom"
        },
        title: {
          display: false,
          text: this.titulo
        },
        responsive: true,
        scales: {
          xAxe: {
            gridLines: {
              display: false
            }
          },
          yAxes: [
            {
              display: true,
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        hover: {
          mode: "nearest",
          intersect: true
        }
      }
    };
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
  watch: {
    chartData: () => {
      try {
        this.renderChart(this.chartData, this.options);
      } catch (error) {
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/charts/Linechart.vue